import Dashboard from "layouts/dashboard";
import Ec2StartStop from "layouts/ec2startstop";
import Ec2Disponilidad from "layouts/ec2disponibilidad";
import Ec2FrontOnOff from "layouts/ec2frontonoff";
import Ec2AwsResize from "layouts/ec2AwsResize";
import AgentesPos1 from "layouts/agentesPos1";
import Ec2Metricas from "layouts/ec2AwsMetricas";
import Tminformes from "layouts/informes";
import RdsAws from "layouts/rdsAws";
import CostosSiesa from "layouts/costos";
import Tmrecepcion from "layouts/recepcionMail";
import ClientesZeusOp from "layouts/clientesZeusOp";
import DeepClient from "layouts/deepClient";
import BackupCreator from "layouts/backupCreator";
import AccesosPos1 from "layouts/accesosPos1";
import UsersBalancer from "layouts/usersBalancer";
import iconStartStop from "assets/images/icons/startstop_icon_black.ico";
import iconDispo from "assets/images/icons/dispo.ico";
import iconOnOff from "assets/images/icons/onoff_icon_black.ico";
import iconResize from "assets/images/icons/resize_icon_black.ico";
import iconEc2 from "assets/images/icons/ec2_icon_black.ico";
import iconEc2Metricas from "assets/images/icons/metricas_balck.ico";
import iconRds from "assets/images/icons/rds_icon_black.ico";
import iconInformes from "assets/images/icons/informes_icon_black.ico";
import iconZeus from "assets/images/icons/Zeus40.ico";
import iconRecepcion from "assets/images/icons/recepcion_icon_black.ico";
import iconAccesos from "assets/images/icons/icono-accesos.ico";
import iconUsersBalancer from "assets/images/icons/load-balancer-icon.ico";
// @mui icons
import Icon from "@mui/material/Icon";
import fetchData from "verticales/FetchData";
import iconUsuarios from "assets/images/icons/icono_usuario.ico";
import icon from "assets/theme/components/icon";
const urlEc2 = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/";

const mapResuource = new Map();
mapResuource.set("ec2-aws-start-stop", <Ec2StartStop />);
mapResuource.set("ec2-disponibilidad", <Ec2Disponilidad />);
mapResuource.set("Ec2-On-Off", <Ec2FrontOnOff />);
mapResuource.set("ec2-aws-resize", <Ec2AwsResize />);
mapResuource.set("agentes-pos1", <AgentesPos1 />);
mapResuource.set("ec2-aws-metricas", <Ec2Metricas />);
mapResuource.set("rds-aws", <RdsAws />);
mapResuource.set("informes", <Tminformes />);
mapResuource.set("recepcion-mail", <Tmrecepcion />);
mapResuource.set("deep-client", <DeepClient />);
mapResuource.set("clientes-zeus-op", <ClientesZeusOp />);
mapResuource.set("backup-creator", <BackupCreator />);
mapResuource.set("accesos-pos1", <AccesosPos1 />);
mapResuource.set("costos", <CostosSiesa />);
mapResuource.set("ec2-users-balancer", <UsersBalancer />);

const mapIcons = new Map();
mapIcons.set("ec2-aws-start-stop", iconStartStop);
mapIcons.set("ec2-disponibilidad", iconDispo);
mapIcons.set("Ec2-On-Off", iconOnOff);
mapIcons.set("ec2-aws-resize", iconResize);
mapIcons.set("agentes-pos1", iconEc2);
mapIcons.set("ec2-aws-metricas", iconEc2Metricas);
mapIcons.set("rds-aws", iconRds);
mapIcons.set("informes", iconInformes);
mapIcons.set("recepcion-mail", iconRecepcion);
mapIcons.set("deep-client", iconRecepcion);
mapIcons.set("clientes-zeus-op", iconZeus);
mapIcons.set("backup-creator", iconRds);
mapIcons.set("accesos-pos1", iconAccesos);
mapIcons.set("costos", iconInformes);
mapIcons.set("ec2-users-balancer", iconUsersBalancer);

const routes = async () => {
  let result = await fetchData(urlEc2, "resource", { action: "get-resurce-by-usuario" });
  let myArray = [];
  if (result && result.length > 0) {
    for (let objResult of result) {
      console.log("mapResuource.get(objResult.name).....", mapResuource.get(objResult.name));
      let objRoutes = {
        type: "collapse",
        name: objResult.name,
        key: objResult.name,
        icon: <img src={mapIcons.get(objResult.name)} />,
        route: objResult.name,
        component: mapResuource.get(objResult.name) ?? <Dashboard />,
      };
      myArray.push(objRoutes);
    }
  }
  return myArray;
};

export default routes;
